import { render, staticRenderFns } from "./MobileIndustry.vue?vue&type=template&id=43ffafe8&scoped=true"
import script from "./MobileIndustry.vue?vue&type=script&lang=js"
export * from "./MobileIndustry.vue?vue&type=script&lang=js"
import style0 from "./MobileIndustry.vue?vue&type=style&index=0&id=43ffafe8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffafe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ffafe8')) {
      api.createRecord('43ffafe8', component.options)
    } else {
      api.reload('43ffafe8', component.options)
    }
    module.hot.accept("./MobileIndustry.vue?vue&type=template&id=43ffafe8&scoped=true", function () {
      api.rerender('43ffafe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileIndustry.vue"
export default component.exports